<template>
    <view-analytics-base
        :currentRoute="currentRoute"
        :currentTitle="'Направления'"
        :rowLabel="'Направление'"
        :subColumnLabel="''"
        :rowTitleLimitIndex="0"
    />
</template>

<script>
/** пока что вывожу направление через клиентов, позже компоненты могут стать разными */
import schemeApi from '../../schemes/schemeApi';
import ViewAnalyticsBase from "@/views/ViewAnalytics/ViewAnalyticsBase";
let {routeAnalyticsDirections} = schemeApi;
export default {
    name: 'ViewAnalyticsDirections',
    components: {
      ViewAnalyticsBase
    },
    /**
     * данные компонента
     * @property {string} currentRoute - текущий маршрут
     */
    data: () => ({
        currentRoute: routeAnalyticsDirections
    })
}
</script>